module.exports = __webpack_public_path__ + "assets/img/18_1844.2b70e61a.jpg";